import React, { Component } from "react";
import Visual from "../../component/pc/Visual";
import Popup from "../../component/pc/Popup";
import Consent from "../../component/pc/Consent";
import Notice from "../../component/pc/Notice";
import Button from "../../component/pc/Button";
import Banner from "../../component/pc/Banner";
import { CookieLoad } from "../../common/Utils";

//import { GoogleTranslateElementInit } from "../../common/Utils";

class Wrap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      login_jwt: CookieLoad("LOGIN_JWT"),
      theWheel: null,
      currentEventInfo: null,
      participantInfo: null,
      eventResultInfo: null,
      segNumber: null,
      userId: null,
      attendanceType: 1, // ATTENDANCE_TYPE (1:일반, 2: 포인트 차감)
      reSpinFlag: false,
    };
  }

  getEventResultInfo = () => {
    let eventType = this.getUrlParams() !== null ? (this.getUrlParams().type !== undefined ? this.getUrlParams().type : "NORMAL-ROULETTE-1") : "NORMAL-ROULETTE-1";
    let apiUrl = `${process.env.REACT_APP_PRIZE_EVENT_API_URL}/prizeEvent/${eventType}/participant`;
    return fetch(apiUrl, {
      method: "POST",
      headers: {
        LOGIN_JWT: this.state.login_jwt,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ attendanceType: this.state.attendanceType }),
    })
      .then((response) => response.json())
      .then((result) => {
        return result;
      });
  };

  getParticipantInfo = () => {
    let eventType = this.getUrlParams() !== null ? (this.getUrlParams().type !== undefined ? this.getUrlParams().type : "NORMAL-ROULETTE-1") : "NORMAL-ROULETTE-1";
    let apiUrl = `${process.env.REACT_APP_PRIZE_EVENT_API_URL}/prizeEvent/${eventType}/participants`;

    return fetch(apiUrl, {
      method: "GET",
      headers: {
        LOGIN_JWT: this.state.login_jwt,
      },
    })
      .then((response) => response.json())
      .then((result) => {
        return result;
      });
  };

  getSegNumber = (goodsCode) => {
    for (let goodsIndex in this.state.currentEventInfo.goodsList) {
      if (
        this.state.currentEventInfo.goodsList[goodsIndex].goodsCode ===
        goodsCode
      ) {
        return parseInt(goodsIndex) === 0
          ? this.state.currentEventInfo.goodsList.length
          : parseInt(goodsIndex);
      }
    }
  };

  callPopup = (result) => {
    if (result.response.status === 200) {
      let self = this;
      this.setState({
        login_jwt: this.state.login_jwt,
        theWheel: this.state.theWheel,
        currentEventInfo: this.state.currentEventInfo,
        participantInfo: this.state.participantInfo,
        eventResultInfo: result,
        segNumber: this.getSegNumber(result.goodsInfo.goodsCode),
        userId: this.state.userId,
        attendanceType: this.state.attendanceType,
        reSpinFlag: this.state.reSpinFlag,
      });

      this.state.theWheel.draw();
      this.state.theWheel.stopAnimation(false);
      this.state.theWheel.rotationAngle = 0;

      if (this.state.segNumber < 7) {
        let stopAt = this.state.theWheel.getRandomForSegment(
          parseInt(this.state.segNumber)
        );
        this.state.theWheel.animation.stopAngle = stopAt;

        this.state.theWheel.startAnimation();

        this.setState({
          login_jwt: this.state.login_jwt,
          theWheel: this.state.theWheel,
          currentEventInfo: this.state.currentEventInfo,
          participantInfo: this.state.participantInfo,
          eventResultInfo: this.state.eventResultInfo,
          segNumber: this.state.segNumber,
          userId: this.state.userId,
          attendanceType: this.state.attendanceType,
          reSpinFlag: true,
        });
      }

      setTimeout(function () {
        if (result.goodsInfo.goodsType === "POINT") {
          document.getElementsByClassName("re_popup_w_point")[0].className = "re_popup_w_point current";
          self.setState({
            login_jwt: self.state.login_jwt,
            theWheel: self.state.theWheel,
            currentEventInfo: self.state.currentEventInfo,
            participantInfo: self.state.participantInfo,
            eventResultInfo: self.state.eventResultInfo,
            segNumber: self.state.segNumber,
            userId: self.state.userId,
            attendanceType: 1,
            reSpinFlag: true,
          });
        } else if (result.goodsInfo.goodsType === "GIFTICON") {
          document.getElementsByClassName("re_popup_w_gifticon")[0].className = "re_popup_w_gifticon current";
          self.setState({
            login_jwt: self.state.login_jwt,
            theWheel: self.state.theWheel,
            currentEventInfo: self.state.currentEventInfo,
            participantInfo: self.state.participantInfo,
            eventResultInfo: self.state.eventResultInfo,
            segNumber: self.state.segNumber,
            userId: self.state.userId,
            attendanceType: 2,
            reSpinFlag: true,
          });
        } else {
          document.getElementsByClassName("re_popup_w_fail")[0].className =
            "re_popup_w_fail current";
          self.setState({
            login_jwt: self.state.login_jwt,
            theWheel: self.state.theWheel,
            currentEventInfo: self.state.currentEventInfo,
            participantInfo: self.state.participantInfo,
            eventResultInfo: self.state.eventResultInfo,
            segNumber: self.state.segNumber,
            userId: self.state.userId,
            attendanceType: 2,
            reSpinFlag: true,
          });
        }
      }, 4000);
    } else if (result.response.status === 400) {
      document.getElementsByClassName("re_popup_w_already")[0].className =
        "re_popup_w_already current";
      this.setState({
        login_jwt: this.state.login_jwt,
        theWheel: this.state.theWheel,
        currentEventInfo: this.state.currentEventInfo,
        participantInfo: this.state.participantInfo,
        eventResultInfo: this.state.eventResultInfo,
        segNumber: this.state.segNumber,
        userId: this.state.userId,
        attendanceType: 2,
        reSpinFlag: false,
      });
    } else if (result.response.status === 500) {
      alert(result.response.info);
    }
  };

  calculatePrize = (btnType) => {
    this.checkedLogin();
    if (document.getElementById("consentChk").checked) {
      if (this.state.attendanceType === 1) {
        // 유저 이벤트 상태 타입 확인
        this.getEventResultInfo().then((result) => {
          if (result) {
            this.callPopup(result);
          }
        });
      } else if (this.state.attendanceType === 2) {
        if (btnType === "point") {
          this.getEventResultInfo().then((result) => {
            if (result?.response) {
              if (result.response.code === 429) {
                alert(result.response.info || '하루 이벤트 참여 회수를 초과하셨습니다.\r\n내일 다시 참여해 주세요.');
              } else {
                this.callPopup(result);
              }
            }
          });
        } else {
          document.getElementsByClassName("re_popup_w_already")[0].className =
            "re_popup_w_already current";
          this.setState({
            login_jwt: this.state.login_jwt,
            theWheel: this.state.theWheel,
            currentEventInfo: this.state.currentEventInfo,
            participantInfo: this.state.participantInfo,
            eventResultInfo: this.state.eventResultInfo,
            segNumber: this.state.segNumber,
            userId: this.state.userId,
            attendanceType: 2,
            reSpinFlag: false,
          });
        }
      }
    } else {
      if (this.state.login_jwt !== "" && this.state.login_jwt !== null) {
        alert("개인정보 수집 동의가 필요합니다.");
        document.querySelector('.re_consent_w').scrollIntoView(false);
      }
    }
  };

  makeRullet(goodsList) {
    const tmpArr = [];
    if (goodsList.length > 0) {
      for (let goodsIndex in goodsList) {
        tmpArr.push({ text: goodsList[goodsIndex].goodsTitle });
      }
    }
    return tmpArr;
  }

  setGnbCss() {
    const gnbCssLink = document.createElement("link"),
      gnbCssUrl = process.env.REACT_APP_GNB_PC_CSS_URL;

    gnbCssLink.rel = "stylesheet";
    gnbCssLink.type = "text/css";
    gnbCssLink.href = gnbCssUrl;

    document.head.appendChild(gnbCssLink);
  }

  setGnbJs() {
    const self = this;
    const gnbJsLink = document.createElement("script"),
      gnbJsUrl = process.env.REACT_APP_GNB_PC_JS_URL;

    gnbJsLink.type = "text/javascript";
    gnbJsLink.charset = "utf-8";
    gnbJsLink.src = gnbJsUrl;
    gnbJsLink.id = "gnbJs";
    gnbJsLink.async = true;

    document.head.appendChild(gnbJsLink);

    document.getElementById(gnbJsLink.id).addEventListener("load", () => {
      self.setState({
        login_jwt: self.state.login_jwt,
        theWheel: self.state.theWheel,
        currentEventInfo: self.state.currentEventInfo,
        participantInfo: self.state.participantInfo,
        eventResultInfo: self.state.eventResultInfo,
        segNumber: self.state.segNumber,
        userId: self.state.userId,
        attendanceType: self.state.attendanceType,
        reSpinFlag: self.state.reSpinFlag,
      });

      window.SbsGnbApp('', {
        env: 'real',
        platform: 'desktop',
        header: {
          id: "header",
          type: 'simple',
          color: 'black',
          section: 'event'
        },
        footer: {
          id: "footer",
          type: 'simple',
          color: 'black'
        },
        use: {
          async: true,
          logging: process.env.REACT_APP_IS_DEV === 'N'
        }
      }).then(function (app) {
        return app;
      }).catch(function (error) {
        console.error(error);
      });
    });
  }

  setCssFile() {
    const cssUrl = `${process.env.PUBLIC_URL}/css/common_pc.css`;
    const link = document.createElement("link");

    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = cssUrl;

    document.head.appendChild(link);
  }

  checkedLogin() {
    if (!this.state.login_jwt) {
      if (window.confirm("로그인이 필요한 페이지입니다. 로그인 하시겠습니까?")) {
        let returnUrl = encodeURIComponent(window.location.href);
        window.location.href = "https://join.sbs.co.kr/login/login.do?div=pc_login&returnUrl=" + returnUrl;
      }
    }
  }

  getUrlParams() {
    let params = {};
    if (window.location.search !== "") {
      window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (
        str,
        key,
        value
      ) {
        params[key] = value;
      });
    } else {
      params = null;
    }

    return params;
  }

  componentDidMount() {
    let self = this;

    this.setCssFile(); // css 세팅
    // gnb 세팅
    if (this.getUrlParams() !== null) {
      if (this.getUrlParams().gnbYn === 'Y' || this.getUrlParams().gnbYn === undefined) {
        this.setGnbCss();
        this.setGnbJs();
      }
    } else {
      this.setGnbCss();
      this.setGnbJs();
    }

    let eventType = this.getUrlParams() !== null ? (this.getUrlParams().type !== undefined ? this.getUrlParams().type : "NORMAL-ROULETTE-1") : "NORMAL-ROULETTE-1";

    //현재 참여중인 이벤트 정보
    fetch(
      `${process.env.REACT_APP_PRIZE_EVENT_API_URL}/prizeEvent/${eventType}`
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.response.status === 404) {
          alert('지금은 이벤트 기간이 아닙니다. \n곧 이벤트가 오픈되니 조금만 기다려주세요!');
          document.location.href = '//www.sbs.co.kr';
        } else {
          this.setCssFile(); // css 세팅

          this.setState({
            login_jwt: this.state.login_jwt,
            theWheel: this.state.theWheel,
            currentEventInfo: result,
            participantInfo: this.state.participantInfo,
            eventResultInfo: this.state.eventResultInfo,
            segNumber: this.state.segNumber,
            userId: this.state.userId,
            attendanceType: this.state.attendanceType,
            reSpinFlag: this.state.reSpinFlag,
          });

          const segmentsArr = this.makeRullet(
            this.state.currentEventInfo.goodsList
          );

          let theWheel = new window.Winwheel({
            numSegments: segmentsArr !== null ? segmentsArr.length : 0, // Specify number of segments.
            outerRadius: 640, // Set outer radius so wheel fits inside the background.
            drawMode: "image", // drawMode must be set to image.
            drawText: false, // Need to set this true if want code-drawn text on image wheels.
            textFontSize: 0,
            segments: segmentsArr, // Define segments. (돌림판이미지의 시계방향 순서로 들어갑니다)
            // Specify the animation to use. (별다른 요구사항 없으면 기본 그대로 넣어주세요)
            animation: {
              type: "spinToStop",
              duration: 5, // Duration in seconds.
              spins: 8, // Number of complete spins.
              callbackFinished: this.alertPrize, // 애니메이션 종료되면 팝업창 노출해주세요.
            },
          });

          this.setState({
            login_jwt: this.state.login_jwt,
            theWheel: theWheel,
            currentEventInfo: this.state.currentEventInfo,
            participantInfo: this.state.participantInfo,
            eventResultInfo: this.state.eventResultInfo,
            segNumber: this.state.segNumber,
            userId: this.state.userId,
            attendanceType: this.state.attendanceType,
            reSpinFlag: this.state.reSpinFlag,
          });

          let loadedImg = new Image();
          loadedImg.onload = function () {
            self.state.theWheel.wheelImage = loadedImg; // Make wheelImage equal the loaded image object.
            self.state.theWheel.draw(); // Also call draw function to render the wheel.
          };
          loadedImg.src = this.state.currentEventInfo.eventInfo.eventImgUrlPc;
        }
      })
      .catch((e) => console.log(e));

    // 참여자 정보
    this.getParticipantInfo().then((result) => {
      if (result.response.code === 200) {
        this.setState({
          login_jwt: this.state.login_jwt,
          theWheel: this.state.theWheel,
          currentEventInfo: this.state.currentEventInfo,
          participantInfo: result,
          eventResultInfo: this.state.eventResultInfo,
          segNumber: this.state.segNumber,
          userId: CookieLoad("SBS_ID"),
          attendanceType: this.state.attendanceType,
          reSpinFlag: this.state.reSpinFlag,
        });
      }
    });
  }

  render() {
    return (
      <>
        <div className="roulette_event_wrap">
          <h3 className="hide">SBS회원대상 룰렛이벤트페이지</h3>
          {/* 룰렛 영역 */}
          <Visual
            currentEventInfo={this.state.currentEventInfo}
            onCalculatePrize={() => this.calculatePrize("start")}
          />
          {/* 팝업 영역 current 걸면 노출 (4가지)*/}
          <Popup
            participantInfo={this.state.participantInfo}
            eventResultInfo={this.state.eventResultInfo}
            currentEventInfo={this.state.currentEventInfo}
            userId={this.state.userId}
            onClick={() => this.calculatePrize("point")}
          />
          {/* 하단 홍보 배너 */}
          <Banner
            currentEventInfo={this.state.currentEventInfo}
          />
          {/* 개인정보 수집 동의 */}
          <Consent
            userId={this.state.userId}
            currentEventInfo={this.state.currentEventInfo}
          />
          {/* 주의사항 */}
          <Notice currentEventInfo={this.state.currentEventInfo} />
          {/* 닫기 버튼 */}
          <Button />
        </div>
      </>
    );
  }
}

export default Wrap;
